/**
 * compareSemver — iter-258
 *
 * Pure-JS, dependency-free semver-ish comparator. Returns:
 *   -1  if `a < b`
 *    0  if `a == b`
 *    1  if `a > b`
 *
 * Tolerant of partial / non-strict versions:
 *   compareSemver("1.2", "1.2.0")   → 0
 *   compareSemver("0.1.0", "0.1.1") → -1
 *   compareSemver("2", "1.99.99")   → 1
 *   compareSemver("0", "0")         → 0     (unknown vs unknown)
 *   compareSemver("", "0.1.0")      → -1    (treat empty as 0)
 *
 * Pre-release suffixes (`-beta.1`, `-rc.0`) are stripped before
 * comparison — good enough for our "show update pill" use case, which
 * only cares about major.minor.patch.
 */
export default function compareSemver(a, b) {
  const A = toParts(a);
  const B = toParts(b);
  const len = Math.max(A.length, B.length);
  for (let i = 0; i < len; i++) {
    const x = A[i] ?? 0;
    const y = B[i] ?? 0;
    if (x < y) return -1;
    if (x > y) return 1;
  }
  return 0;
}

function toParts(v) {
  if (v == null) return [0];
  const str = String(v).trim().split("-")[0]; // drop pre-release suffix
  if (!str) return [0];
  return str
    .split(".")
    .map((p) => {
      const n = parseInt(p, 10);
      return Number.isFinite(n) ? n : 0;
    });
}
